import CmsModel from '@/models/Cms';

const CLEAR_SUBJECT_INFO = 'CLEAR_SUBJECT_INFO';
const GET_SUBJECT_INFO = 'GET_SUBJECT_INFO';
const GET_VALUE_BY_KEY = 'GET_VALUE_BY_KEY';

/**
 * 清除专题页信息
 */
async function clearSubjectInfo() {
  return {
    type: CLEAR_SUBJECT_INFO,
  }
}

/**
 * 获取专题页信息
 * @param {Number} id 专题id
 */
async function getSubjectInfo(id) {
  const payload = await new CmsModel().subjectInfo(id);
  return {
    type: GET_SUBJECT_INFO,
    payload
  }
}

/**
 * 获取专题配置信息
 * @param {String} key
 */
async function getValueByKey(key) {
  const payload = await new CmsModel().getValueByKey(key);
  return {
    type: GET_VALUE_BY_KEY,
    payload
  }
}

const ACTION_TYPES = {
  CLEAR_SUBJECT_INFO,
  GET_SUBJECT_INFO,
  GET_VALUE_BY_KEY,
};

const ACTION = {
  clearSubjectInfo,
  getSubjectInfo,
  getValueByKey,
};

const Subject = {
  ACTION_TYPES,
  ACTION
}

export default Subject;